import React from "react";
import {
    drawTextCell,
    GridCellKind,
    TextCellEntry,
} from "@glideapps/glide-data-grid";

import { MarkdownSmallCell } from 'components/Markdown'

const Editor = cell => {
    const cellData = cell.value.data;
    const { value } = cellData;
    
    if (cell.value.readonly) {
        return (
            <TextCellEntry
                highlight={true}
                autoFocus={false}
                disabled={true}
                value={value ?? ""}
                onChange={() => undefined}
            />
        );
    }

    return (
        <MarkdownSmallCell >{value}</MarkdownSmallCell>
    );
};

const renderer = {
    kind: GridCellKind.Custom,
    isMatch: (cell) => cell.data?.kind === "markdown",
    draw: (args, cell) => {
        let { displayData } = cell.data;
        try{
        drawTextCell(args, displayData, cell.contentAlign);
        } catch(e) {
            console.error(e);
        }
        return true;
    },
    measure: (ctx, cell, theme) => {
        const { value } = cell.data;
        return ctx.measureText(value).width + theme.cellHorizontalPadding * 2;
    },
    provideEditor: () => ({
        editor: Editor,
    }),
    onPaste: (v, d) => {
        return {
            ...d,
            value: v,
        };
    },
};

export default renderer;
